import { Checkbox } from '../Checkbox';
import { Icon } from '../Icon';
import { RadioButton } from '../RadioButton';
import {
    Label,
    LabelContainer,
    OptionDescription,
    OptionTypeContainer,
    SelectOptionContainer,
    SelectOptionIcon,
} from './style';
import { SelectOptionProps } from './types';

export const SelectOption = ({
    checked,
    description,
    direction,
    disabled,
    icon,
    label,
    onChange,
    type,
    value,
    name,
}: SelectOptionProps) => (
    <SelectOptionContainer
        as="label"
        checked={checked}
        direction={direction}
        disabled={disabled}
        gap="0"
        autoFlow={direction === 'vertical' ? 'row' : 'column'}
        alignItems={direction === 'vertical' ? 'start' : 'center'}
        templateColumns={direction === 'horizontal' ? `max-content ${icon ? 'max-content auto' : 'auto'}` : 'auto'}
    >
        <OptionTypeContainer>
            {type === 'checkbox' ? (
                <Checkbox onChange={onChange} value={value} disabled={disabled} checked={checked} name={name} />
            ) : (
                <RadioButton name={name} checked={checked} value={value} onChange={onChange} disabled={disabled} />
            )}
        </OptionTypeContainer>
        {icon ? (
            <SelectOptionIcon itemAlignment="center" alignment="center" direction={direction}>
                <Icon value={icon} size={'medium'} />
            </SelectOptionIcon>
        ) : null}
        <LabelContainer vertical itemAlignment="start" alignment="center" direction={direction}>
            <Label>{label}</Label>
            {description ? <OptionDescription>{description}</OptionDescription> : null}
        </LabelContainer>
    </SelectOptionContainer>
);
